import type { NavItem } from '@os/ui';
import { addonWeb } from './catalog';
import type { AddonDashboard } from './types';

export type AddonEnablement = { id: string; enabled: boolean };

function enabledIds(enabled: AddonEnablement[]): Set<string> {
  return new Set(enabled.filter((a) => a.enabled).map((a) => a.id));
}

/**
 * Insert each enabled addon's nav (as that addon wrote it) before the host **App** group.
 * If the host has no App group, extras are appended.
 */
export function mergeAddonNav(hostNav: NavItem[], enabled: AddonEnablement[]): NavItem[] {
  const on = enabledIds(enabled);
  const extra = addonWeb.filter((m) => on.has(m.id)).flatMap((m) => m.nav);
  if (extra.length === 0) return hostNav;
  const appIdx = hostNav.findIndex((it) => 'group' in it && it.group === 'App');
  if (appIdx === -1) return [...hostNav, ...extra];
  return [...hostNav.slice(0, appIdx), ...extra, ...hostNav.slice(appIdx)];
}

/** Dashboard slots from enabled addons. Disabled addons and empty configs contribute nothing. */
export function enabledAddonDashboards(enabled: AddonEnablement[]): { id: string; dashboard: AddonDashboard }[] {
  const on = enabledIds(enabled);
  return addonWeb.flatMap((m) => {
    if (!on.has(m.id) || !m.dashboard) return [];
    const { kpis, widgets } = m.dashboard.config;
    if (kpis.length === 0 && widgets.length === 0) return [];
    return [{ id: m.id, dashboard: m.dashboard }];
  });
}
